import type { InternalAuditReportTestResultsByControlIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetInternalAuditReportTestResultsByControlIdQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetInternalAuditReportTestResultsByControlIdDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createLazyQueryHook } from 'src/utils';

type UseLazyGetInternalAuditReportTestResultsByControlIdArgs = {
  controlId: string;
};

export const useLazyGetInternalAuditReportTestResultsByControlId =
  createLazyQueryHook<
    UseLazyGetInternalAuditReportTestResultsByControlIdArgs,
    InternalAuditReportTestResultsByControlIdResponseRow[],
    GetInternalAuditReportTestResultsByControlIdQuery
  >({
    trpcQuery: (client, { controlId }) =>
      client.frontend.testResult.internalAuditReportTestResultsByControlId.query(
        { controlId }
      ),
    mapTrpcDataToGraphQL: (data) => ({
      control_test_internal_audit_result: data,
    }),
    graphqlDocument: GetInternalAuditReportTestResultsByControlIdDocument,
    graphqlVariables: ({ controlId }) => ({ controlId }),
  });
